<form class="login-form" (submit)="onSubmit($event)">
  <div
    *ngIf="errorMessage"
    class="auth-alert"
    [class.auth-alert-warning]="errorType === 'network'"
    [class.auth-alert-error]="errorType === 'credentials' || errorType === 'server' || errorType === 'unknown'"
    role="alert"
    aria-live="assertive"
  >
    <span class="auth-alert-icon" aria-hidden="true">
      <svg *ngIf="errorType === 'network'" viewBox="0 0 24 24" width="18" height="18">
        <path d="M2 8.5 C 7 4 17 4 22 8.5 M5 12 C 9 8.5 15 8.5 19 12 M8.5 15.5 C 10.5 14 13.5 14 15.5 15.5"
              fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        <line x1="3" y1="3" x2="21" y2="21" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        <circle cx="12" cy="19" r="1.2" fill="currentColor"/>
      </svg>
      <svg *ngIf="errorType !== 'network'" viewBox="0 0 24 24" width="18" height="18">
        <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.8"/>
        <line x1="12" y1="7" x2="12" y2="13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        <circle cx="12" cy="16.5" r="1.1" fill="currentColor"/>
      </svg>
    </span>
    <div class="auth-alert-body">
      <span class="auth-alert-title">
        {{
          (errorType === 'network'     ? 'auth.alerts.networkTitle' :
           errorType === 'server'      ? 'auth.alerts.serverTitle' :
           errorType === 'credentials' ? 'auth.alerts.credentialsTitle' :
                                         'auth.alerts.unknownTitle') | translate
        }}
      </span>
      <span class="auth-alert-text">{{ errorMessage }}</span>
    </div>
    <button type="button" class="auth-alert-close" (click)="dismissError()" [attr.aria-label]="'common.cerrar' | translate">
      <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
        <path d="M6 6 L18 18 M18 6 L6 18" fill="none" stroke="currentColor"
              stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </div>

  <dx-form
    labelLocation="top"
    [formData]="formData"
    [disabled]="loading"
    [showColonAfterLabel]="true"
  >
    <dxi-form-item
      dataField="email"
      editorType="dxTextBox"
      [editorOptions]="emailEditorOptions"
    >
      <dxi-form-validation-rule
        type="required"
        [message]="'auth.usuarioRequired' | translate"
      ></dxi-form-validation-rule>
      <dxo-form-label [text]="'auth.usuario' | translate"></dxo-form-label>
    </dxi-form-item>

    <dxi-form-item
      dataField="password"
      editorType="dxTextBox"
      [editorOptions]="passwordEditorOptions"
    >
      <dxi-form-validation-rule
        type="required"
        [message]="'auth.contrasenaRequired' | translate"
      ></dxi-form-validation-rule>
      <dxo-form-label [text]="'auth.contrasena' | translate"></dxo-form-label>
    </dxi-form-item>

    <dxi-form-item
      dataField="rememberMe"
      editorType="dxCheckBox"
      [editorOptions]="rememberMeEditorOptions"
      cssClass="remember-row"
    >
      <dxo-form-label [visible]="false"></dxo-form-label>
    </dxi-form-item>

    <dxi-form-item itemType="button">
      <dxo-form-button-options
        width="100%"
        type="default"
        cssClass="btn-sign-in"
        [useSubmitBehavior]="true"
        [template]="'signInTemplate'"
      >
      </dxo-form-button-options>
    </dxi-form-item>

    <ng-container *dxTemplate="let item of 'signInTemplate'">
      <span class="dx-button-text">
        <ng-container *ngIf="loading; else notLoading">
          <dx-load-indicator
            width="22px"
            height="22px"
            [visible]="true"
          ></dx-load-indicator>
        </ng-container>
        <ng-template #notLoading>
          <span class="btn-label">{{ 'auth.ingresar' | translate }}</span>
          <svg class="btn-arrow" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
            <path d="M5 12 h14 M13 6 l6 6 -6 6" fill="none" stroke="currentColor"
                  stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </ng-template>
      </span>
    </ng-container>
  </dx-form>

  <div class="form-helper-row">
    <a class="forgot-link" [routerLink]="resetLink">{{ 'auth.olvideContrasena' | translate }}</a>
  </div>

  <div class="form-divider" aria-hidden="true">
    <span class="line"></span>
    <span class="text">{{ 'auth.accesoSeguro' | translate }}</span>
    <span class="line"></span>
  </div>

  <div class="security-note">
    <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
      <path d="M12 2 L4 6 v6 c0 5 3.5 8.5 8 10 4.5-1.5 8-5 8-10 V6 z"
            fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
      <path d="M9 12 l2 2 4-4" fill="none" stroke="currentColor" stroke-width="1.7"
            stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span>{{ 'auth.sesionCifrada' | translate }}</span>
  </div>
</form>
